import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';

export default function SentinelLayout() {
  return (
    <Stack sx={{ height: '100%', overflow: 'hidden' }}>
      <Header />
      <Stack direction="row" sx={{ height: 'calc(100% - 64px)', mt: 0.5, gap: 0.5, overflow: 'auto', px: 0.5, pb: 0.5 }}>
        <Outlet />
      </Stack>
    </Stack>
  );
}
